import Vue from 'vue'
import utilFormData from '../../utils/objectToForm'

export default (id) => {
  let url = `taxreceipt/taxreceipt/getcomplement/${id}/`
  return Vue.$http.get(url)
    .then((response) => {
      let data = response.data
      return data
    })
}



// WEBPACK FOOTER //
// ./src/services/taxReceipt/getComplements.js